export class Voice {
	public voiceId: string
	public name: string
	public category?: string
	public accent?: string
	public description?: string
	public age?: string
	public gender?: string
	public useCase?: string
	public previewUrl?: string
	public collectionIds?: string[]

	constructor(data: {
		voiceId: string
		name: string
		category?: string
		accent?: string
		description?: string
		age?: string
		gender?: string
		useCase?: string
		previewUrl?: string
		collectionIds?: string[]
	}) {
		this.voiceId = data.voiceId
		this.name = data.name
		this.category = data.category
		this.accent = data.accent
		this.description = data.description
		this.age = data.age
		this.gender = data.gender
		this.useCase = data.useCase
		this.previewUrl = data.previewUrl
		this.collectionIds = data.collectionIds
	}

	static create(data: Partial<Voice>): Voice {
		const defaultData = {
			voiceId: '',
			name: '',
			category: undefined,
			accent: undefined,
			description: undefined,
			age: undefined,
			gender: undefined,
			useCase: undefined,
			previewUrl: undefined,
			collectionIds: undefined,
		}

		return new Voice({ ...defaultData, ...data })
	}

	// Helper to get a display name with accent (accent removed temporarily)
	getDisplayName(): string {
		if (this.accent) {
			return `${this.name}`
		}
		return this.name
	}

	// Helper to get full description
	getFullDescription(): string {
		const parts: string[] = []
		if (this.description) parts.push(this.description)
		if (this.age) parts.push(this.age)
		if (this.gender) parts.push(this.gender)
		if (this.accent) parts.push(this.accent)
		return parts.join(' • ')
	}

	playVoiceDemoForVoice(): HTMLAudioElement | null {
		// Check if the voice has a preview URL
		if (!this.previewUrl) {
			console.error('No preview URL available for this voice')
			return null
		}

		// Play the demo without selecting the voice
		const audio = new Audio(this.previewUrl)
		audio.play()
		return audio
	}
}
